import { StorageKey } from '@core/storage/storage-keys.enum';
import { DateTimeHelper } from '@shared/helpers/DateTimeHelper';

export abstract class StorageBaseService {
    protected abstract readonly storage: Storage;

    /**
     * Gets a saved item from SessionStorage
     * @param key
     * @param options
     */
    getItem<R>(key: StorageKey, options?: { decode: boolean }): R | undefined {
        let item = this.storage.getItem(key);
        try {
            if (options?.decode) {
                item = atob(item);
            }
            return JSON.parse(item, (k, v) => this.jsonReviver(k, v)) as R;
        } catch (e) {
            return undefined;
        }
    }

    /**
     * Saves an item in SessionStorage. Type param is essential to avoid unwanted behaviours in the caching process
     * @param key
     * @param value
     * @param options
     */
    saveItem<T>(key: StorageKey, value: T, options?: { encode: boolean }): void {
        let stringToSave = JSON.stringify(value, (k, v) => this.jsonReplacer(k, v));
        if (options?.encode) {
            stringToSave = btoa(stringToSave);
        }
        this.storage.setItem(key, stringToSave);
    }

    protected jsonReviver<T>(key: string, value: T): unknown {
        const validDate = typeof value === 'string' && DateTimeHelper.validDate(value);
        return validDate ? new Date(value as string) : value;
    }

    protected jsonReplacer<T>(key: string, value: T): unknown {
        return value instanceof Map ? Array.from(value) : value;
    }
}
